import { wordForm } from "@/utils/text/wordForm";
import { ACTION_ISSUE, ACTION_RESTORE, ACTION_WITHDRAW, ACTION_WRITEOFF, ACTION_TRANSFER } from "../constants";

const types = {
    [ACTION_ISSUE]: "Выдача сотруднику",
    [ACTION_WITHDRAW]: "Изъятие у сотрудника",
    [ACTION_WRITEOFF]: "Списание",
    [ACTION_RESTORE]: "Восстановление",
    [ACTION_TRANSFER]: "Передача сотруднику",
};

export function HistoryAction(data) {
    const { action, author, comment, date, id, inventoryHistoryFiles, worker, recipientWorker } = data;

    const type = types[action];

    const files = (inventoryHistoryFiles || []).map((file) => {
        const { id, name } = file;

        return {
            id,
            url: name,
            name: name.split("/").pop(),
        };
    });

    const filesText = files.length ? `${files.length} ${wordForm(files.length, ["файл", "файла", "файлов"])}` : "";

    return {
        id,
        date,
        actor: author,
        type,
        worker: String(action) === ACTION_TRANSFER ? recipientWorker : worker,
        comment,
        files,
        filesText
    };
}
